import React from 'react';
import { Container } from 'react-bootstrap';

const Skills = () => {
    return (
        <div>
            <Container>
                <h1 className="mt-5 mb-3 fst-italic fw-bold">My Skills</h1>
                <h6 className="fw-bold">Comfortable With:</h6>
                <p className="mt-3 fst-italic"> <span className="fw-bold">Web Development</span> - HTML,  CSS,JavaScript,  React JS, Mongodb,  Bootstrap, Tailwind,Material UI,Express,express. <br />
                <span className="fw-bold">Familiar-with</span>- Axios,Node.js, Stripe, dotenv, React Native, Redux <br />
                <span className="fw-bold">Hosting</span>- FIrebase, Netlify, Heroku . <br />
                <span className="fw-bold">Tools</span>-  Git, VS Code, Chrome Dev Tools, Figma(for design).
                Database- Mongodb.
                </p>

                
                
                 
                
            </Container>
        </div>
    );
};

export default Skills;